import { ComponentType, FC } from 'react'
import { useMounted } from '../hooks'

export const withMounted =
  <P extends object>(Component: ComponentType<P>, Fallback?: ComponentType): FC<P> =>
  // eslint-disable-next-line react/display-name
  (props) => {
    const isMounted = useMounted()

    if (!isMounted) {
      if (!Fallback) return null
      return <Fallback />
    }

    return <Component {...(props as P)} />
  }
